import { useCallback } from 'react';

/**
 * Hook for handling review submission and refreshing related data
 * @param {Object} params - Parameters
 * @param {Function} params.refreshAfterHire - Function to refresh hiring data
 * @param {Function} params.refreshReviews - Function to refresh reviews
 * @param {Function} params.refreshUserReviewCheck - Function to refresh user review check
 * @returns {Function} handleReviewSubmitted callback
 */
const useReviewSubmission = ({
  refreshAfterHire,
  refreshReviews,
  refreshUserReviewCheck
}) => {
  const handleReviewSubmitted = useCallback(() => {
    // Refresh hiring data and reviews after review is submitted
    refreshAfterHire();
    // Refresh reviews to check if user has already reviewed
    refreshReviews();
    // Refresh the user review check
    refreshUserReviewCheck();
  }, [refreshAfterHire, refreshReviews, refreshUserReviewCheck]);

  return handleReviewSubmitted;
};

export default useReviewSubmission;

